import React, { useEffect, useState } from "react";
import { Modal, Button, Row, Col, Form, InputGroup } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { API_ENDPOINTS } from "../../constant/_constant";
import { toast } from "react-toastify";
import usePostRequest from "../../hooks/usePostRequest";
import { useNavigate } from "react-router-dom";
import "rsuite/dist/rsuite.css";

function RfqIdEditPopup({ show, onClose, rfqId }) {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    watch,
    setValue,
  } = useForm();

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    message: "",
    btntext: "",
    title: "",
  });
  const navigate = useNavigate();

  const { data: editedOrder, postData: editOrderId } = usePostRequest(
    API_ENDPOINTS.EDIT_ORDERID,
  );

  const onSuccessEdit = (res) => {
    toast.success(res?.message || "Opportunity ID changed successfully.");
    navigate(`/list-opportunities`);
  };

  const onErrorEdit = (err) => {
    toast.error(
      err?.message ||
        "Some error occured while editing the Opportunity ID, please try again.",
    );
  };

  const onSubmit = async (data) => {
    const response = await editOrderId(
      {
        target_id: data.order_id,
        source_id: rfqId,
        module_type: "RFQ",
      },
      onSuccessEdit,
      onErrorEdit,
    );
  };

  return (
    <>
      <Modal show={show} onHide={onClose} centered>
        <Modal.Header
          className="justify-content-center d-block text-center"
          closeButton
        >
          <Modal.Title className="tittle_deal">
            <span className="text-green">Edit Opportunity ID</span>
          </Modal.Title>
          <p className="mb-0">Please enter the new Opportunity ID below.</p>
        </Modal.Header>

        <Form>
          <Modal.Body>
            <div className="mb-3 fw-bold">
              Current Opportunity ID: <span className="text-primary">{rfqId}</span>
            </div>

            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">New Opportunity ID</Form.Label>
              <InputGroup>
                <Form.Control
                  {...register("order_id")}
                  placeholder="Enter Opportunity ID"
                  defaultValue={rfqId}
                />
              </InputGroup>
            </Form.Group>
          </Modal.Body>

          <Modal.Footer className="justify-content-center">
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="warning"
              type="button"
              onClick={handleSubmit(onSubmit)}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}

export default RfqIdEditPopup;
